import { Alert, Slide, Snackbar } from "@mui/material";
import React from "react";

export const ErrorSnackbar = ({ error, handleCloseError, errorMsg }) => {
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    handleCloseError(false);
  };

  return (
    <Snackbar
      open={error}
      autoHideDuration={5000}
      onClose={handleSnackbarClose}
      TransitionComponent={(props) => <Slide {...props} direction="up" />}
    >
      <Alert severity="error" variant="filled" sx={{ width: "100%" }}>
        {errorMsg}
      </Alert>
    </Snackbar>
  );
};

export const ConfirmationSnackbar = ({
  snackbarState,
  handleSnackbarClose,
  action,
  text,
}) => {
  return (
    <Snackbar
      open={snackbarState}
      autoHideDuration={6000}
      onClose={handleSnackbarClose}
    >
      <Alert
        severity="success"
        variant="filled"
        sx={{ width: "100%", color: "#fff" }}
      >
        {text}
      </Alert>
    </Snackbar>
  );
};
